module.exports = __webpack_public_path__ + "static/media/role.4802bcbd.svg";